var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _class2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { attr, belongsTo } from '@ember-data/model';
import { notEmpty } from '@ember/object/computed';
import TrackRelationships from 'ember-data-relationship-tracker';
import DeviceProfile from '@square/dashboard-data/models/device-profile';
import DeviceProfileSettings from '@square/dashboard-data/models/device-profile-settings';
import { fetchDeviceProfile } from '@square/dashboard-data/services/devices/device-profile';
import Enum from '@square/dashboard-utilities/utils/enum';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
const JSON_KEYS = new Set(['name', 'deleted', 'subunit', 'token', 'deviceProfile', 'sharedDeviceProfileToken']);
const DEVICE_PROFILE_KEYS = new Set(['version', 'settings', 'token']);
export const DeviceCredentialStatuses = new Enum(['active', 'unpaired', 'expired']);
const PROFILE_ATTRIBUTES = new Set(['deviceProfile', 'sharedDeviceProfile']);
let DeviceCredential = (_dec = service('devices/default-device-profiles'), _dec2 = attr('string', {
  defaultValue: ''
}), _dec3 = attr('boolean'), _dec4 = belongsTo('merchant-subunit-ed', {
  async: false
}), _dec5 = attr('string', {
  readOnly: true
}), _dec6 = attr('string'), _dec7 = attr('string', {
  readOnly: true
}), _dec8 = attr('proto-base-model', {
  modelClass: DeviceProfile,
  embedded: true
}), _dec9 = attr('proto-base-model', {
  modelClass: DeviceProfile,
  embedded: true,
  readOnly: true
}), _dec10 = attr('string', {
  readOnly: true
}), _dec11 = attr('string'), _dec12 = notEmpty('sharedDeviceProfileToken'), _dec13 = computed('deviceProfile.isDirty', 'hasDirtyAttributes', 'hasDirtyRelationships'), (_class = (_class2 = class DeviceCredential extends EmberDataBaseModel.extend(TrackRelationships) {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "relationshipTrackerVersion", 0);
    _initializerDefineProperty(this, "defaultDeviceProfilesService", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    // These fields are synced with the server
    _initializerDefineProperty(this, "name", _descriptor3, this);
    _initializerDefineProperty(this, "deleted", _descriptor4, this);
    _initializerDefineProperty(this, "subunit", _descriptor5, this);
    // Valid status values are defined in SqWeb in app/registerpro/presenters/device_credential_presenter.rb
    _initializerDefineProperty(this, "statusCode", _descriptor6, this);
    _initializerDefineProperty(this, "token", _descriptor7, this);
    // Password is only sent down from web on create and set on show password and reset password
    _initializerDefineProperty(this, "password", _descriptor8, this);
    // Device settings that are configurable in dashboard
    _initializerDefineProperty(this, "deviceProfile", _descriptor9, this);
    _initializerDefineProperty(this, "sharedDeviceProfile", _descriptor10, this);
    // Token for device-specific profile, always exists
    _initializerDefineProperty(this, "deviceProfileToken", _descriptor11, this);
    // Token for the shared profile, nullable
    _initializerDefineProperty(this, "sharedDeviceProfileToken", _descriptor12, this);
    // If a device has a shared device profile token, it's using a shared profile
    _initializerDefineProperty(this, "isUsingSharedDeviceProfile", _descriptor13, this);
  }
  // If subunit is set directly, then it does not dirty the model.
  watchAndSetSubunit(subunit) {
    this.watchRelationship('subunit', () => this.set('subunit', subunit));
  }
  loadDeviceProfile() {
    this.set('isLoadingProfile', true);
    fetchDeviceProfile(this).then(deviceProfile => {
      this.set('deviceProfile', deviceProfile);
    }).catch(() => {
      this.set('couldNotFetchProfile', true);
    }).finally(() => {
      this.set('isLoadingProfile', false);
    });
  }
  setSharedDeviceProfile(profile) {
    this.set('sharedDeviceProfile', profile);
    this.set('sharedDeviceProfileToken', profile ? profile.get('token') : null);
  }
  syncSettings() {
    const sharedSettings = this.sharedDeviceProfile?.settings;
    this.set('deviceProfile.settings', DeviceProfileSettings.newCopyFromSettings(sharedSettings));
  }
  async save() {
    // Web expects private settings to match shared device settings
    if (this.sharedDeviceProfile) {
      this.syncSettings();
    }

    // Because of the TrackRelationships mixin, `this._super` doesn't resolve to the model.
    await super.save();

    // The relationship tracker requires that we have a version field that changes when the model is saved.
    this.incrementProperty('relationshipTrackerVersion');
    return this;
  }
  makeSharedProfilePrivate() {
    this.syncSettings();
    this.setSharedDeviceProfile(null);
  }

  // Only name, deleted, unit_token, token, shared_device_profile_token and device_profile should be sent up to web
  toJSON() {
    const json = super.toJSON();
    // Sending null shared_device_profile_token means "change me to have no shared profile".
    // If creating a new non-shared device profile, we shouldn't send the shared_device_profile_token field at all.
    // Doing so will result in a 400 from the server
    if (this.isNew && !json.sharedDeviceProfileToken) {
      delete json.sharedDeviceProfileToken;
    }
    Object.keys(json).forEach(key => {
      if (!JSON_KEYS.has(key)) {
        delete json[key];
      }
    });
    // Only version, token, and settings should be sent up to web
    if (json['deviceProfile']) {
      Object.keys(json['deviceProfile']).forEach(key => {
        if (!DEVICE_PROFILE_KEYS.has(key)) {
          delete json['deviceProfile'][key];
        }
      });
    }
    return json;
  }
  duplicate() {
    const newDevice = this.store.createRecord('device-credential');
    newDevice.set('name', this.intl.t('business.devices.deviceCode.copy', {
      oldDeviceName: this.name
    }));
    const baseDeviceSettings = this.deviceProfile?.settings;
    if (this.isUsingSharedDeviceProfile) {
      const deviceType = this.deviceProfile?.type;
      this.defaultDeviceProfilesService.createDefault(deviceType).then(profile => {
        newDevice.set('deviceProfile', profile);
      });
      // If using shared device settings, copy over the shared profile.
      newDevice.setSharedDeviceProfile(this.sharedDeviceProfile);
    } else if (baseDeviceSettings) {
      // If using individual device settings, make a deep copy of the device profile settings.
      newDevice.set('deviceProfile', DeviceProfile.create({
        settings: DeviceProfileSettings.deserialize(DeviceProfileSettings.serialize(baseDeviceSettings))
      }));
    }
    return newDevice;
  }
  get isDirty() {
    return this.deviceProfile?.isDirty || this.hasDirtyRelationships || [...Object.keys(this.changedAttributes())].any(key => !PROFILE_ATTRIBUTES.has(key));
  }
  revert() {
    // for new records, we want the existing Ember Data behavior
    if (this.isNew) {
      this.rollbackAttributes();
      this.rollbackRelationships();
      return;
    }
    // For Existing records, we need to modify behavior.
    // because we use `matchDeviceProfileToCredentials` to set the deviceProfile, emberData always thinks the
    // profile has been changed initially. check to see if it's from `null` before removing;
    Object.entries(this.changedAttributes()).forEach(([attribute, [oldValue]]) => {
      if (PROFILE_ATTRIBUTES.has(attribute) && isEmpty(oldValue)) {
        return;
      }
      this.set(attribute, oldValue);
    });
    this.rollbackRelationships();
  }
  delete() {
    this.set('deleted', true);
    return this.save();
  }

  // Called to reset the device when the delete call fails
  didNotDelete() {
    this.set('deleted', false);
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'device-credential'), _defineProperty(_class2, "url", '/api/v1/device_credentials'), _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "defaultDeviceProfilesService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "deleted", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "subunit", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "statusCode", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "token", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "password", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "deviceProfile", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "sharedDeviceProfile", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "deviceProfileToken", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "sharedDeviceProfileToken", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "isUsingSharedDeviceProfile", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isDirty", [_dec13], Object.getOwnPropertyDescriptor(_class.prototype, "isDirty"), _class.prototype)), _class));
export { DeviceCredential as default };